<template>
    <svg
        width="51"
        height="44"
        viewBox="0 0 51 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
    <path
        id="iconColor"
        d="M5.6 0.00195312L5.72 0.0119534C6.63 0.121953 7.46 0.461954 8.09 1.02195L8.26 1.18195L10.47 3.24195C12.93
        3.74195 15.26 5.38195 17.46 7.82195L17.75 8.14195L18.02 8.46195C18.98 9.60195 19.85 10.812 20.62 12.032L20.81
        12.342L21.16 12.932L21.27 13.132H22.4L30.75 13.222L36.21 13.312C38.49 13.312 40.68 14.122 42.44 15.602L42.7
        15.832L45.47 18.262C46.44 19.082 46.48 20.532 45.61 21.382L45.49 21.492L44.76 22.132C43.84 22.922 42.47 23.072
        41.37 22.472L41.2 22.372L38.22 20.272L38.8 26.272L41.65 32.802L41.8 32.732C42.42 32.412 43.1 32.012 43.78
        31.572L44.18 31.302L44.48 31.092C45.09 30.722 45.8 30.492 46.43 30.492C47.48 30.492 48.46 30.922 49.17 31.752C50.48
        33.312 50.22 35.642 48.64 36.762L48.53 36.832L48.23 37.062C43.15 40.922 35.95 43.672 26.76 43.962L26.14 43.982L25.52
        43.992C14.65 44.142 6.82 41.432 1.4 37.382C0.51 36.742 0 35.712 0 34.582C0 33.812 0.190001 33.112 0.610001 32.582C1.61
        31.062 3.61 30.642 5.26 31.542C5.73 31.812 6.16 32.032 6.61 32.242L6.84 32.352L7.34 32.572L7.84 32.782L8.32 32.972L9.72
        28.202C10.2 26.732 10.46 25.212 10.49 23.662V23.142L10.48 22.742L9.22 16.432L6.72 17.602L6.59 17.702C5.63 18.402 4.1
        18.452 2.96 17.982L2.76 17.892L2.66 17.842L2.25 17.682L2.12 17.602C0.860001 16.842 0.240001 15.272 0.650001 13.872L0.71
        13.692L0.76 13.572L4.17 7.05195L4.6 2.40195V1.00195C4.6 0.481953 5 0.0519531 5.5 0.00195312H5.6ZM6.73 2.49195L6.6
        2.39195V2.53195L6.15 7.43195C6.14 7.52195 6.12 7.60195 6.09 7.68195L6.04 7.80195L2.58 14.422L2.56 14.492C2.46 14.922
        2.62 15.422 2.95 15.732L3.05 15.822L3.1 15.862L3.46 16.002L3.57 16.052C4.12 16.362 5.16 16.342 5.46 16.042C5.52 15.982
        5.58 15.932 5.65 15.892L5.76 15.832L9.59 14.092C10.14 13.842 10.77 14.132 10.95 14.692L10.98 14.802L12.51 22.422L12.53
        22.572C12.62 24.532 12.38 26.482 11.83 28.322L11.69 28.782L9.98 34.572C9.81 35.142 9.19 35.442 8.65 35.212L6.95 34.522L6.33
        34.262L5.81 34.022C5.31 33.792 4.83 33.542 4.33 33.262C3.59 32.8619 2.73 33.032 2.27 33.732C2.11 33.932 2.04 34.212 2.04
        34.562C2.04 35.062 2.25 35.482 2.63 35.752C7.72 39.562 15.12 42.122 25.54 41.982C34.87 41.912 42.08 39.252 47.05 35.472L47.37
        35.222L47.46 35.162C48.12 34.752 48.26 33.732 47.67 33.042C47.36 32.672 46.94 32.492 46.46 32.492C46.22 32.492 45.86 32.6119
        45.6 32.762C44.24 33.712 42.69 34.592 41.53 35.042C41.07 35.222 40.55 35.032 40.3 34.612L40.25 34.512L36.93 26.912C36.9 26.852
        36.88 26.782 36.87 26.712L36.85 26.612L36.02 18.292C35.94 17.482 36.81 16.932 37.5 17.322L37.59 17.382L42.3 20.702C42.6 20.892
        43.04 20.882 43.34 20.692L43.43 20.622L44.17 19.972C44.22 19.932 44.23 19.872 44.19 19.812L44.15 19.772L41.36 17.322C40 16.102
        38.29 15.392 36.49 15.322L30.7 15.222L22.36 15.132H20.65C20.28 15.132 19.94 14.922 19.76 14.592L19.54 14.192L19.39 13.932L19.06
        13.382C19 13.282 18.94 13.192 18.88 13.092C18.16 11.952 17.35 10.812 16.45 9.75195C14.28 7.19195 12.01 5.52195 9.8 5.16195C9.64
        5.13195 9.5 5.07195 9.37 4.98195L9.28 4.90195L6.83 2.61195L6.77 2.55195L6.73 2.49195ZM18.16 26.972C18.27 26.972 18.38 26.992 18.48
        27.022C22.43 28.352 26.63 28.532 30.44 28.042L31.01 27.962L31.51 27.882L31.77 27.832L31.87 27.812C32.24 27.732 32.61 27.862 32.85
        28.142L32.92 28.242L37.5 35.302C37.84 35.822 37.62 36.5219 37.05 36.762C35.14 37.572 33.05 38.122 30.81 38.422C26.49 39.012 21.88
        38.692 17.41 37.802C16.57 37.632 15.8 37.462 15.09 37.282L14.47 37.122L13.69 36.902C13.67 36.892 13.66 36.892 13.64 36.892C13.09
        36.722 12.8 36.112 13 35.592L13.11 35.362L16.81 28.162C16.92 27.942 17.03 27.742 17.14 27.582C17.44 27.172 17.65 26.972 18.16
        26.972ZM18.92 29.252L18.56 29.142L16.13 33.862L15.39 35.292L15.58 35.342C16.12 35.482 16.7 35.612 17.32 35.742L17.79 35.842C22.06
        36.692 26.45 36.992 30.53 36.442C31.98 36.242 33.36 35.942 34.64 35.522L35.13 35.352L31.59 29.882C31.4 29.912 31.21 29.942 31
        29.972L30.68 30.012C26.96 30.512 22.87 30.392 18.92 29.252Z"
        fill="#747474"
    />
    <path
        id="iconColor"
        d="M31.02 13.002H22.1C21.56 13.002 21.11 13.432 21.1 13.982L21.02 18.662C21.02 21.582 23.43 24.002 26.43 24.002C29.34 24.002
        31.81 21.802 31.93 18.992L32.02 14.022C32.03 13.462 31.58 13.002 31.02 13.002ZM23.08 15.002H30L29.94 18.762C29.94 20.552 28.35
        22.002 26.43 22.002C24.54 22.002 23.02 20.482 23.02 18.692L23.08 15.002Z"
        fill="#747474" />
</svg>
</template>

<script>
export default {
  name: 'IconHorse',
};
</script>
